export default class List {
  constructor(opts = {}) {
    this.store = opts.store;
    this.node = opts.node;
    this.id = this.node.dataset.id;
    this.rectTop = this.node.getBoundingClientRect().top;
    this.node.addEventListener('click', () => {
      this.handleClick();
    });
  }

  handleClick() {
    this.rewriteIdStore();
    // MarkerAndListSync.getInstance().render();
    this.store.masterInstance.render();
  }

  rewriteIdStore() {
    this.store.crId = this.id;
  }

  active() {
    this.node.classList.add(this.store.className.listActive);
  }

  inactive() {
    this.node.classList.remove(this.store.className.listActive);
  }
}
